module.exports = __webpack_public_path__ + "img/s-mob-9.66fd8bda.webp";